import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'

import { Service } from '../../../types'
import { useChangeCareersActions } from './hooks/useChangeCareersActions'
import { ChangeCareersInfo, Steps } from './hooks/useChangeCareersConfig'

import * as Styles from './styles'

type ActionButtonsProps = {
  steps: Steps
  text: ChangeCareersInfo
  service: Service
}

export const ActionButtons = ({ text, steps, service }: ActionButtonsProps) => {
  const { isPhone } = useMediaQueries()
  const { features } = useFeaturesConfig()
  const { handleCareerPath, handleAssessments, handleOpenBookCoach } = useChangeCareersActions()

  const getAssessmentData = () => {
    if (!steps.assessments.completed && text.assessmentButton) {
      return {
        text: isPhone ? text.assessmentButtonMobile : text.assessmentButton,
        score: steps.assessments.score,
      }
    }
    if (!steps.career_path.completed) {
      return {
        text: isPhone ? text.careerPathButtonMobile : text.careerPathButton,
        score: steps.career_path.score,
      }
    }
    return { text: text.careerPathButton, score: steps.career_path.score }
  }

  const getCoachData = () => {
    if (steps.book_coach.completed) {
      return { text: text.bookCoachAgain, score: steps.book_coach.score }
    }
    return { text: text.bookCoachButton, score: 0 }
  }

  const handleClick = () => {
    trackInternalEvent('progress_cta_click', {
      score: service.title,
      cta: getAssessmentData().text,
    })
    if (!steps.assessments.completed) return handleAssessments()
    return handleCareerPath()
  }

  const handleCoachClick = () => {
    trackInternalEvent('progress_cta_click', {
      score: service.title,
      cta: getCoachData().text,
    })
    handleOpenBookCoach()
  }

  const showScore = (completed?: boolean, score?: number) => {
    if (isPhone) return null

    if (completed) {
      return (
        <Styles.IconContainer>
          <Styles.Icon />
        </Styles.IconContainer>
      )
    }
    return <Styles.ScoreText>+{score}%</Styles.ScoreText>
  }

  return (
    <Styles.ProgressActionButtonsContainer data-testid="change-careers-action-buttons-progress">
      <Styles.ButtonContainer
        onClick={handleClick}
        data-testid="change-careers-assessment-button-progress"
      >
        <Styles.ActionText>{getAssessmentData().text}</Styles.ActionText>
        {showScore(false, getAssessmentData().score)}
      </Styles.ButtonContainer>
      {features.careerCoaching && (
        <Styles.ButtonContainer
          onClick={handleCoachClick}
          data-testid="change-careers-book-coach-button-progress"
        >
          <Styles.ActionText>{getCoachData().text}</Styles.ActionText>
          {showScore(!getCoachData().score, getCoachData().score)}
        </Styles.ButtonContainer>
      )}
    </Styles.ProgressActionButtonsContainer>
  )
}
